// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--1MLUx";
export var loader__dot = "Loader-module--loader__dot--35Ani";
export var loader_absolute = "Loader-module--loader_absolute--fNzQs";